export const JSONSafeParse = (jsonString) => {
    try {
        return JSON.parse(jsonString);
    }
    catch (e) {
        return {};
    }
};
